module.exports = __webpack_public_path__ + "static/media/blog_list1.b2c79202.jpg";